<template>
  <PageContentWrapper>
    <div class="flex flex-col md:w-10/12 lg:w-8/12 gap-2 -mx-4 md:mx-auto text-gray-800">
      <h1 class="hidden md:block text-center text-gray-900">
        {{ isCompany ? 'Unser Account' : 'Mein Account' }}
      </h1>

      <div class="md:hidden flex flex-row items-center justify-between mx-4 mt-5">
        <span class="font-semibold text-lg">Zwei-Faktor-Authentifizierung</span>
        <ElTag :type="isTwoFactorEnabled ? 'success' : 'info'" round>
          {{ isTwoFactorEnabled ? 'aktiviert' : 'deaktiviert' }}
        </ElTag>
      </div>
      <ElCard class="mb-10">
        <Heading
          level="5"
          text="Zwei-Faktor-Authentifizierung"
          :icon="{name: 'shield', variant: 'regular', class: 'text-secondary mr-2'}"
          class="hidden md:block border-b border-gray-200 pb-2 mb-6 font-semibold"
        >
          <ElTag
            :type="isTwoFactorEnabled ? 'success' : 'info'"
            class="inline-block float-right"
            round
          >
            {{ isTwoFactorEnabled ? 'aktiviert' : 'deaktiviert' }}
          </ElTag>
        </Heading>

        <TwoFactorForm
          :two-factor-enabled="isTwoFactorEnabled"
          @state-change="isTwoFactorEnabled = $event"
        />
      </ElCard>

      <template v-if="isNativePlatform">
        <span class="md:hidden mx-4 font-semibold text-lg">App schützen</span>
        <ElCard class="mb-10">
          <Heading
            level="5"
            text="App schützen"
            :icon="{name: 'lock', variant: 'regular', class: 'text-secondary mr-2'}"
            class="hidden md:block border-b border-gray-200 pb-2 mb-6 font-semibold"
          />
          <BiometryAuthForm />
        </ElCard>
      </template>

      <template v-if="false">
        <span class="md:hidden mx-4 font-semibold text-lg">Benachrichtigungseinstellungen</span>
        <ElCard class="mb-10">
          <Heading
            level="5"
            text="Benachrichtigungseinstellungen"
            :icon="{name: 'bell', variant: 'regular', class: 'text-secondary mr-2'}"
            class="hidden md:block border-b border-gray-200 pb-2 mb-6 font-semibold"
          />

          <p>
            Hier {{ duzen('kannst du', 'können Sie') }} einstellen, wofür {{ duzen('du', 'Sie') }}
            auf welchem Weg benachrichtigt werden {{ duzen('möchtest', 'möchten') }}.
          </p>

          <NotificationSettingsForm />
        </ElCard>
      </template>

      <span class="md:hidden mx-4 font-semibold text-lg">Zugangsdaten ändern</span>
      <ElCard class="mb-10">
        <Heading
          level="5"
          text="Zugangsdaten ändern"
          :icon="{name: 'key', variant: 'regular', class: 'text-secondary mr-2'}"
          class="hidden md:block border-b border-gray-200 pb-2 mb-6 font-semibold"
        />
        <p>
          Um {{ duzen('dein', 'Ihr') }} Passwort zu ändern, oder wenn noch kein Passwort gesetzt ist,
          {{ duzen('gebe', 'geben Sie') }} ein neues Passwort ein
          und {{ duzen('bestätige', 'bestätigen Sie') }} dieses.
        </p>

        <TheChangePasswordForm :login-email="kundeEmail ?? ''" />
      </ElCard>

      <span class="md:hidden mx-4 font-semibold text-lg">Account löschen</span>
      <ElCard>
        <Heading
          level="5"
          text="Account löschen"
          :icon="{name: 'trash', variant: 'regular', class: 'text-secondary mr-2'}"
          class="hidden md:block border-b border-gray-200 pb-2 mb-6 font-semibold"
        />
        <p>
          Um {{ duzen('deinen', 'Ihren') }} Account vollständig und unwiderruflich zu löschen,
          {{ duzen('bestätige', 'bestätigen Sie') }} dies bitte und {{ duzen('klicke', 'klicken') }}
          im Anschluss auf "Account löschen". Bei Bedarf kann {{ duzen('dein', 'Ihr') }} Berater jederzeit einen
          neuen Account anlegen.
        </p>

        <TheDeleteForm />
      </ElCard>
    </div>
  </PageContentWrapper>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ElCard, ElTag } from 'element-plus';
import Heading from '@/application/components/Heading.vue';

import { storeToRefs } from "pinia";
import { useBaseDataStore } from "@/user/store/baseDataStore";
import TheDeleteForm from "@/user/components/TheDeleteForm.vue";
import TwoFactorForm from "@/user/components/TwoFactorForm.vue";
import TheChangePasswordForm from "@/user/components/TheChangePasswordForm.vue";
import BiometryAuthForm from "@/user/components/BiometryAuthForm.vue";
import { isNativePlatform } from "@/application/utils/envInfo";
import NotificationSettingsForm from "@/user/components/NotificationSettingsForm.vue";
import PageContentWrapper from '@/application/layouts/ContentWrapper/PageContentWrapper.vue';

const { kundeEmail, twoFactorEnabled, isCompany } = storeToRefs(useBaseDataStore());
const { duzen } = useBaseDataStore();

const isTwoFactorEnabled = ref(twoFactorEnabled.value);
</script>
